/**
 * Formats a YYYY-MM-DD date string as a locale date string using local calendar time.
 *
 * Why this matters: `new Date('2026-04-15')` is parsed as UTC midnight per ECMAScript spec.
 * In negative-UTC-offset timezones (e.g. UTC-5), formatting that object for display
 * shows the previous day (April 14). The same problem occurs with `T12:00:00Z` anchoring in
 * extreme positive-offset timezones (e.g. UTC+13).
 *
 * This function uses the local Date constructor `new Date(y, m-1, d)` which interprets the
 * year/month/day in local time, guaranteeing the displayed date matches the stored YYYY-MM-DD
 * string regardless of the user's timezone.
 *
 * The `{ year, month, day }` options render the app-wide house style `Mon D, YYYY`
 * (e.g. `Apr 15, 2026`) — matching `formatDate` and `formatRelativeTimestamp` so the
 * Acknowledgments "Due" subtitle reads the same as the adjacent "Sent" value (#3223).
 *
 * @param dateString - An ISO 8601 date-only string in `YYYY-MM-DD` format.
 * @returns A locale-formatted date string representing the correct calendar day.
 */
export function formatDueDate(dateString: string): string {
    const [y, m, d] = dateString.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
